/* 🤖 this file was generated by script */
export const wiconMinimize02 = {
  name: 'minimize_02',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8h.2c1.68 0 2.52 0 3.16-.33a3 3 0 001.31-1.3C8 5.71 8 4.87 8 3.2V3M3 16h.2c1.68 0 2.52 0 3.16.33a3 3 0 011.31 1.3c.33.65.33 1.49.33 3.17v.2m8-18v.2c0 1.68 0 2.52.33 3.16a3 3 0 001.3 1.31c.65.33 1.49.33 3.17.33h.2m-5 13v-.2c0-1.68 0-2.52.33-3.16a3 3 0 011.3-1.31c.65-.33 1.49-.33 3.17-.33h.2"/></svg>`,
};
